import React, { FunctionComponent } from "react";
import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

const IngredientContributorIcon: FunctionComponent<SvgIconProps> = ({ color, ...props }): JSX.Element => (
	<SvgIcon
		className="csi-icon-color-grey"
		color={color}
		viewBox="0 0 16 16"
		{...props}
	>
		<path d="M12.215 6.70638C11.9466 4.27388 10.0158 2.34305 7.58331 2.07471V0.873047H6.41665V2.07471C3.98415 2.34305 2.05331 4.27388 1.78498 6.70638H0.583313V7.87305H1.78498C2.05331 10.3055 3.98415 12.2364 6.41665 12.5047V13.7064H7.58331V12.5047C10.0158 12.2364 11.9466 10.3055 12.215 7.87305H13.4166V6.70638H12.215ZM6.99998 11.373C4.7454 11.373 2.91665 9.5443 2.91665 7.28971C2.91665 5.03513 4.7454 3.20638 6.99998 3.20638C9.25456 3.20638 11.0833 5.03513 11.0833 7.28971C11.0833 9.5443 9.25456 11.373 6.99998 11.373Z" fill="#79818F" />
	</SvgIcon>
);

export default IngredientContributorIcon;
